import { useQuote } from "./useQuote";
import { Grid, LinearProgress, Typography } from "@mui/material";
import QuoteEdit from "./QuoteEdit";
import QuoteView from "./QuoteView";

const QuotePage = () => {
  const { quote, isLoading, prepareQuote } = useQuote();

  if (isLoading) {
    return (
      <Grid container>
        <Grid size={12}>
          <LinearProgress data-testid="loading-indicator" />
        </Grid>
      </Grid>
    );
  }

  if (!quote) {
    return (
      <Grid
        container
        sx={{
          marginTop: 2,
          marginBottom: 2,
        }}
      >
        <Typography variant="h5">Taka wycena nie istnieje</Typography>
      </Grid>
    );
  }

  if (quote.status === "INVALIDATED") {
    return (
      <Grid
        container
        sx={{
          marginTop: 2,
          marginBottom: 2,
        }}
      >
        <Typography variant="h5">Prośba o wycenę została anulowana</Typography>
      </Grid>
    );
  }

  return quote.prepared ? <QuoteView quote={quote} /> : <QuoteEdit quote={quote} onSubmit={prepareQuote} />;
};

export default QuotePage;
